import store from 'redux/store';
import { flashMessage } from 'redux-flash';

export default (message: string, options: any = {}) =>
  store.dispatch(flashMessage(message, options));
